import BackupTableIcon from '@mui/icons-material/BackupTable'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'

import Services from '../services'

export const HR_EXIT_INTERVIEW_OPTIONS = (slug?: string) => [
  {
    icon: <PictureAsPdfIcon />,
    label: 'Download PDF',
    link: `${Services.api.hr.downloadExitInterviewPDF(slug)}`,
    type: 'download',
  },

  {
    icon: <BackupTableIcon />,
    label: 'Download CSV',
    link: `${Services.api.hr.downloadExitInterviewCSV(slug)}`,
    type: 'download',
  },
]
